/**
 * @Description 标准版-拓店管理-拓店任务-接口
 */

import { get, post } from '@/common/request/index';

/**
 * @description 拓店任务列表
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/99610
 */
export function getExpansionTaskList(params?:any) {
  return post('/standard/task/page', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 模糊搜索用
 */
export function getTaskSimplePage(params?:any) {
  return post('/standard/task/simplePage', { ...params }, {
    isMock: false,
    mockId: 644,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 拓店任务列表(益禾堂)
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/82284
 */
export function getYhtTaskList(params?:any) {
  return post('/standard/task/yhtPage', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 拓店任务统计(益禾堂)
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/84622
 */
export function yhtTaskCount(params?:any) {
  return get('/standard/task/yhtCount', { ...params }, {
    isMock: false,
    mockId: 546,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 拓店任务统计
 * @yapi https://yapi.lanhanba.com/project/546/interface/api/72232
 */
export function directTaskCount(params?:any) {
  return get('/direct/task/count', { ...params }, {
    isMock: false,
    mockId: 546,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 拓店任务导出
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/63307
 */
export function taskListExport(params?:any) {
  return post('/standard/task/export', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 拓店任务导出（益禾堂）
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/82305
 */
export function taskListYhtExport(params?:any) {
  return post('/standard/task/yhtExport', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 拓店任务类型列表
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/62852
 */
export function taskTypeList() {
  return get('/standard/task/typeList', {}, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 拓店签约类型列表
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/65085
 */
export function taskSignTypeList() {
  return get('/standard/task/signTypeList', {}, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 修改拓店任务类型
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/63146
 */
export function updateTaskType(params) {
  return post('/standard/task/updateType', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 拓店任务类型变更记录
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/63160
 */
export function taskTypeChangeRecords(params) {
  return post('/standard/task/typeChangeRecords', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 创建拓店任务
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/99606
 */
export function createExpansionTask(params?:any) {
  return post('/standard/task/create', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 拓店任务详情
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/99612
 */
export function getExpansionTaskDetail(params?:any) {
  return get('/standard/task/detail', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 更新拓店任务
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/99608
 */
export function updateExpansionTask(params?:any) {
  return post('/standard/task/update', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 添加沟通纪要
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/59401
 */
export function addCommunicateRecord(params?:any) {
  return post('/standard/task/addCommunicateRecord', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 获取可被关联的机会点列表
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/59443
 */
export function getTaskChancePointList(params?:any) {
  return post('/standard/task/chancePointPage', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * 解除绑定
 * https://yapi.lanhanba.com/project/532/interface/api/59072
 */
export function releaseAssociate(params: any) {
  return post(`/standard/task/releaseAssociate`, params, {
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 拓店任务关联的机会点
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/59450
 */
export function associateTask(params?:any) {
  return post('/standard/task/associate', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}


/**
 * @description 校验审批表单信息(校验必填项)
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/60143
 */
export function checkApprovalForm(params?:any) {
  return post('/approval/form/check', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * 拓店任务关联机会点点位评估直接通过（比如semir）
 * https://yapi.lanhanba.com/project/532/interface/api/88828
 */
export function passStandardChancepoint(params: any) {
  return post(`/standard/chancePoint/evaluate/pass`, params, {
    needHint: true,
    isTerra: true,
  });
}

/**
 * 直接通过点位评估
 * https://yapi.lanhanba.com/project/532/interface/api/81178
 */
export function passTaskChancepoint(params: any) {
  return post(`/standard/chancePoint/pass`, params, {
    needHint: true,
    isTerra: true,
  });
}

/**
 * @description 拓店任务历史列表
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/59597
 */
export function taskHistory(params?: any) {
  return get('/standard/task/history', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}


/**
 * 拓店任务&加盟商详情
 * https://yapi.lanhanba.com/project/532/interface/api/68963
 */
export function getTaskInfo(params:any) {
  return get(`/standard/task/detailWithFranchisee`, params);
}

/**
 * 拓店任务关联的机会点完成进度
 * https://yapi.lanhanba.com/project/532/interface/api/69243
 */
export function taskChancePointInfo(params:any) {
  return post(`/standard/task/chancePointCompletionInfo`, params, {
    needCancel: false
  });
}

/**
 * 查询沟通纪要
 * https://yapi.lanhanba.com/project/532/interface/api/69229
 */
export function taskRecords(params:any) {
  return get(`/standard/task/communicateRecords`, params);
}

/**
 * 创建卡旺卡拓店任务
 * https://yapi.lanhanba.com/project/532/interface/api/71427
 */
export function createCircleTask(params:any) {
  return post(`/direct/task/create`, params, { isMock: false, mockId: 532, mockSuffix: '/api', needHint: true });
}

export interface LocxxDirectTaskCreateParams {
  modelClusterId: number;
  name: string;
  targetProvinceId?: number;
  targetCityId?: number;
  targetDistrictId?: number;
  followingStatus?: number;
  assignAccountIds?: number[];
  managerId?: number;
  marketingPurpose?: 6 | 7 | 8;
  areaRequirementMin?: number;
  areaRequirementMax?: number;
  floorHeight?: number;
  minFlowBottomLine?: number;
  activityPeriodCount?: number;
  activityPeriodUnit?: 1 | 2 | 3;
  promotionDateStart?: string;
  promotionDateEnd?: string;
  totalBudget: number;
  expectDropInDate: string;
}

const LOCXX_DIRECT_TASK_OPTIONS = { isMock: false, mockId: 532, mockSuffix: '/api', needHint: true };

/**
 * 创建 Locxx 拓店任务
 * https://yapi.lanhanba.com/project/532/interface/api/71427
 */
export function createLocxxDirectTask(params: LocxxDirectTaskCreateParams) {
  return post('/direct/task/create', params, LOCXX_DIRECT_TASK_OPTIONS);
}

/**
 * 编辑拓店任务-商圈拓店模版
 * https://yapi.lanhanba.com/project/532/interface/api/88990
 */
export function postDirectTaskUpdate(params:any) {
  return post('/direct/task/update', params, { isMock: false, mockId: 532, mockSuffix: '/api', needHint: true });
}

/**
 * 拓店任务下拉框
 * https://yapi.lanhanba.com/project/532/interface/api/59387
 */
export function getStandardTaskSelection(params?:any) {
  return get(`/standard/task/selection`, params, { needCancel: false, isMock: false, mockId: 532, mockSuffix: '/api', needHint: true });
}

/**
 * @description 员工绩效报告导出
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/72659
 */
export function employeePerformanceReportExport(params?:any) {
  return post('/standard/home/employee/performanceReport/export', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 公司业绩报告导出
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/72666
 */
export function companyPerformanceReportExport(params?:any) {
  return post('/standard/home/company/performanceReport/export', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 任务统计信息导出
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/72855
 */
export function taskReportExport(params?:any) {
  return post('/standard/home/standardTask/statistics/export', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}



/**
 * @description 客流计数获取可被关联的机会点列表
 * @yapi https://yapi.lanhanba.com/project/329/interface/api/73597
 */
export function getFlowSpotChancePointList(params?:any) {
  return get('/checkSpot/queryRelatedChancePoints', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 指派拓店任务（加盟商任务模板）
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/59086
 */
export function standardTaskAssign(params?: any) {
  return post('/standard/task/assign', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 操作变更记录分页列表
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/89708
 */
export function getHistoryRecordPage(params?: any) {
  return post('/operate/record/pages', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * 加盟商报表列表
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/91099
 */
export function getStandardFranchiseeReportList(params?: any) {
  return post('/standard/franchisee/report/list', { ...params }, { isMock: false, mockId: 532, mockSuffix: '/api', needHint: true });
}

/**
 * 加盟商报表导出
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/91108
 */
export function postStandardFranchiseeReportExport(params?: any) {
  return post('/standard/franchisee/report/export', { ...params }, { isMock: false, mockId: 532, mockSuffix: '/api', needHint: true });
}
